import { API_CONSTANTS } from "./constantInformation";

const statGreenColor = "#09AF0070"
const statYellowColor = "#FFD60090"
const statRedColor = "#E5393590"
const statGrayColor = "gray"
const transparent = "transparent";

export const getStatsColorCoding = (props, information) => {

    let leagueConf;

    if (process.env.REACT_APP_ENV === "production") {
      leagueConf = JSON.parse(props.remoteConfig.config.leagueConf._value);
    }
    else{
      leagueConf = JSON.parse(props.remoteConfig.config.leagueConfTesting._value);
    }
    const selectedLeague = leagueConf.leagues.find(league => league.leagueName === props.league);
    
    const statConfig = selectedLeague.statColorCoding.find(
      (stat) => stat.statName === information.full_name
    )

    if (!statConfig) return transparent;
    
    const { high, mid, low } = statConfig.constraints;
    const statValue = props.player_stats[information.actual_name];

    // Handle edge case for undefined or constant value
    if (statValue === API_CONSTANTS.NUMERIC_CONSTANT) return statGrayColor;

    // Parse stat value if it's a string with a percentage
    const value = typeof statValue === "string"
    ? parseFloat(statValue.replace("%", ""))
    : statValue
    if (statConfig.isDesc) {
      if (value >= high) return statGreenColor;
      else if (value >= mid) return statYellowColor;
      else return statRedColor;
    } else {
      if (value >= high && value < mid) return statGreenColor;
      else if (value >= mid && value < low) return statYellowColor;
      else return statRedColor;
    }

}